<template>
	<form class="page-content edit-page settings-editor" @submit.prevent="save">
		<div class="page-content-header">
			<div class="page-title">
				Settings
			</div>
		</div>
		<div class="page-content-white">
      <div class="buttons">
        <a href="/dashboard" class="button light-grey-button">
          <i class="fas fa-circle-left"></i>
          Close
        </a>
        <button class="button button-primary" :disabled="loading" >
          <i class="fas fa-circle-check"></i>
          Save
        </button>
      </div>

			<tabs>
				<tab name="Pages">
					<div class="form-group">
						<label for="about_us_text" class="col-3">About Us</label>
						<div class="col-9">
						<textarea name="about_us_text"
						          class="form-control"
						          id="about_us_text"
						          v-model="settings.about_us_text.value"
						          cols="30"
						          rows="10"></textarea>
						</div>
					</div>

					<div class="form-group">
						<label for="terms_text" class="col-3">Contact Us</label>
						<div class="col-9">
						<textarea name="terms_text"
						          class="form-control"
						          id="terms_text"
						          v-model="settings.contact_us_text.value"
						          cols="30"
						          rows="10"></textarea>
						</div>
					</div>
				</tab>
			</tabs>
		</div>
	</form>
</template>

<script>
	export default {
		name: "SettingsEditor",
		mounted() {
			this.load()
		},
		data(){
			return {
				loading: false,
				settings: {},
			}
		},
		methods: {
			load(){
				this.loading = true;

				axios.get('/settings/list').then((r) => {
					this.settings = r.data;
					this.$forceUpdate();
				}).finally(() => {
					this.loading = false;
				})
			},
			save(){
				this.loading = true;

				axios.post('/settings/save', {
					settings: this.settings
				}).then((r) => {
					this.loading = false;
					this.settings = r.data;
					this.load();

					this.$dlg.toast('Settings saved!',{
						title: '',
						messageType: 'info',
						closeTime: 2 //auto close dialog time(second)
					});
				})
			},
		}
	}
</script>

